import { Button, Stack, Typography } from '@mui/material';

interface ErrorStateProps {
    onRetry: () => void;
}

export default function ErrorState({ onRetry }: Readonly<ErrorStateProps>) {
    return (
        <Stack spacing={2} sx={{ alignItems: 'center', justifyContent: 'center', height: '100%', p: 3 }}>
            <Typography variant="body1" color="text.secondary" textAlign="center">
                We couldn&apos;t load this conversation.
            </Typography>
            <Button variant="outlined" color="primary" onClick={onRetry}>
                Try again
            </Button>
        </Stack>
    );
}
